import { observable, computed, makeObservable } from 'mobx';
import { createTransformer } from 'mobx-utils';

import polyline from '@mapbox/polyline';
import minBy from 'lodash/minBy';

import { createModelSchema, primitive } from 'serializr';

import { Coords } from '@vromo/models';

export class Polyline {
    encoded: string = '';

    constructor() {
        makeObservable(this, {
            encoded: observable,
            decoded: computed
        });
    }

    get decoded() {
        return polyline.decode(this.encoded).map((it) => new Coords(it[0], it[1])) || [];
    }

    truncate = createTransformer(([lat, lon]: [number, number]) => {
        const path = this.decoded;

        const nearestPoint = minBy(path, ({ lat: lat2, lon: lon2 }) => {
            if (lat2 && lon2) {
                Math.sqrt(Math.pow(lat2 - lat, 2) + Math.pow(lon2 - lon, 2));
            } else {
                return Infinity;
            }
        });

        if (nearestPoint) {
            return path.slice(path.indexOf(nearestPoint));
        } else {
            return [];
        }
    });
}

createModelSchema(Polyline, {
    encoded: primitive()
});
